/* eslint-disable promise/param-names */

const auth = {
  state: {
    token: localStorage.getItem("user-token") || "",
    status: "",
    hasLoadedOnce: false
  },
  mutations: {
    authRequestMutation(state){
      state.status = "loading";
    },
    authSuccessMutation(state, data){
      console.log('authSuccessMutation data',  data);    
      // state.token = data.token;
      state.status = "success";
      state.token = data.token;
      state.hasLoadedOnce = true;
    },
    authErrorMutation(state){
      console.log('authErrorMutation data',  data);    
      state.status = "error";
      state.hasLoadedOnce = true;
    },
    authLogoutMutation(state){
      state.token = "";
    }
  },
  actions: { 
    async registerAction({ commit, dispatch}, user){
      return new Promise((resolve, reject) => {
        commit('authRequestMutation');
        axios.post('/api/register', user)
        .then(({data}) => { 
          console.log('register return data', data); 
          localStorage.setItem("user-token", data.token);
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.token 
          commit('authSuccessMutation', data);  
          resolve(data);    
        })
        .catch((error) => {
          localStorage.removeItem('user-token') ;
          reject(error.response.data);
        });
      })
    },
    async loginAction({ commit, dispatch }, data){
      return new Promise((resolve, reject) => {
        commit('authRequestMutation');
        axios.post('/api/login', data)
        .then(({data}) => { 
          localStorage.setItem("user-token", data.token);   
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.token
          commit('authSuccessMutation', data);
          // dispatch('fetchCurrentUserAction');
          resolve(data); 
        })
        .catch((error) => {
          localStorage.removeItem('user-token');
          reject(error.response.data);
        })
      })
    },
    logoutAction ({ commit }){
      commit('authLogoutMutation');
      localStorage.removeItem("user-token");
      // remove the axios default header
      delete axios.defaults.headers.common['Authorization']; 
    }
  },
  getters: {
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status
  }
}


export default auth
